import * as yup from 'yup'

import { maxRequestCityCount, maxRequestWarehouseCount } from '../config'
import { type WizardValues } from './types'

const titleError = 'Напишите, что нужно сделать: хотя бы три символа'
const shipmentTypesError = 'Отметьте хотя бы одну схему работы: FBO, FBS или DBS'
const marketplaceOtherNameError = 'Напишите, какая ещё площадка вам нужна'
const specialPackingError = 'Опишите, какая упаковка нужна — иначе фулфилмент не сможет посчитать работу'
const phoneError = 'Оставьте телефон — без него фулфилменты не смогут ответить'

export const requestWizardSchema = yup.object({
  title: yup.string().test('title', titleError, (value) => (value ?? '').trim().length >= 3),
  shipmentTypes: yup
    .array()
    .test('shipment-types', shipmentTypesError, (value) => (value ?? []).length > 0)
    .required(),
  marketplaces: yup.array().required(),
  marketplaceOtherName: yup.string().test('marketplace-other-name', marketplaceOtherNameError, function (value) {
    const values = this.parent as WizardValues
    return !values.marketplaces.includes('other') || (value ?? '').trim() !== ''
  }),
  cities: yup
    .array()
    .max(maxRequestCityCount, `Можно указать не более ${maxRequestCityCount} городов — уберите лишние.`)
    .required(),
  warehouses: yup
    .array()
    .max(maxRequestWarehouseCount, `Можно указать не более ${maxRequestWarehouseCount} складов — уберите лишние.`)
    .required(),
  federalDistricts: yup
    .array()
    .test('fbs-districts', 'Выберите хотя бы один федеральный округ', function (value) {
      const values = this.parent as WizardValues
      return !values.shipmentTypes.includes('fbs') || (value ?? []).length > 0
    })
    .required(),
  services: yup.array().required(),
  subjectId: yup.number().nullable().defined(),
  subjectName: yup.string().defined(),
  productUrl: yup.string().defined(),
  productSize: yup.string().defined(),
  packageSize: yup.string().defined(),
  unitCount: yup.string().defined(),
  dueDate: yup.string().defined(),
  description: yup.string().defined(),
  packingType: yup.mixed<NonNullable<WizardValues['packingType']>>().nullable().defined(),
  packingComment: yup.string().defined(),
  needsSpecialPacking: yup.boolean().defined(),
  specialPacking: yup.string().test('special-packing', specialPackingError, function (value) {
    const values = this.parent as WizardValues
    return !values.needsSpecialPacking || (value ?? '').trim() !== ''
  }),
  needsTwiceADay: yup.boolean().defined(),
  requirements: yup.string().defined(),
  phone: yup.string().test('phone', phoneError, (value) => (value ?? '').trim().length >= 5),
  contacts: yup.array().required(),
})
